import React from 'react';

export default class TagsLegends extends React.Component {
    render() {
        let tags = [];
        this.props.lines.forEach(line => {
            line.tags.forEach(tag => {
                const firstCategory = tag.categoriesList[0];
                // console.log(JSON.stringify(tag));
                tags[firstCategory.categoryId]= {name: tag.categoriesList[0].categoryName, colour: firstCategory.colour};
            })
        });
        return <div>
        <center>
        {tags.map(tag => {return <span><span style={{borderColor:'black',borderStyle:'solid',borderWidth:'1px',backgroundColor:'#'+tag.colour}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> {tag.name}&nbsp;&nbsp;</span>})}
        <br/></center>
        <br/>
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/TagsLegends.js